import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { FormInputProps } from "../form-input";
import { FormItemOption } from "../form-builder.model";
import { FormItemLabel } from "./form-item-label";

export type SelectInputProps = {
  options: FormItemOption[];
} & Omit<FormInputProps, "formLayout">;

export const SelectInput: React.FC<SelectInputProps> = ({
  formItem,
  formData,
  setValue,
  options,
}) => {
  const resolvedValue = (): string => {
    const e = formData[formItem.name];
    if (!e) return "";
    else return e as string;
  };
  return (
    <div className="_select-input.tsx select-input">
      <TextField
        id={formItem.name}
        select
        value={resolvedValue()}
        onChange={(evt) => setValue(evt.target.value)}
        slotProps={{
          select: {
            MenuProps: {
              // Prevent body scroll-lock and page scrollbar reflow when menu opens
              disableScrollLock: true,
            },
          },
        }}
        disabled={formItem.disabled}
        fullWidth
        variant="outlined"
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
      >
        {options.map((opt) => (
          <MenuItem
            key={`${opt.value ?? opt.text}`}
            value={opt.value ?? opt.text}
          >
            {opt.text}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};
